var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConfirmFiltro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04998 6.61184L5.75223 9.1875L11.9022 3.32566C12.13 3.10855 12.4199 3 12.7719 3C13.1239 3 13.4138 3.10855 13.6416 3.32566C13.8693 3.54276 13.9886 3.81395 13.9994 4.13921C14.0093 4.46526 13.9004 4.73684 13.6726 4.95395L6.62192 11.6743C6.39415 11.8914 6.10425 12 5.75223 12C5.40022 12 5.11032 11.8914 4.88254 11.6743L1.34166 8.29934C1.11389 8.08224 1 7.80592 1 7.4704C1 7.13487 1.11389 6.85855 1.34166 6.64145C1.56944 6.42434 1.85437 6.31105 2.19644 6.30158C2.53769 6.29132 2.82221 6.39474 3.04998 6.61184Z",
    fill: "#1E1E1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfirmFiltro);
export default __webpack_public_path__ + "static/media/IconConfirmFiltro.105413eac6afe21b2bef11559dff3fed.svg";
export { ForwardRef as ReactComponent };